module.exports = __webpack_public_path__ + "img/m-icon-s-truck.99f6ed28.png";